module.exports = __webpack_public_path__ + "bc586dfe8ccd4850a3357d854d2add05.png";